import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Lock, CheckCircle2, Loader2 } from "lucide-react";
import Logo from "../components/Logo";
import { useAuth } from "../context/AuthContext";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { reset } = useAuth();
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setState("sending");
    try {
      await reset(token, pwd);
      setState("done");
      setTimeout(() => navigate("/login"), 2000);
    } catch (e) {
      setErr(e?.response?.data?.detail || "Could not reset password.");
      setState("idle");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#16244F] to-[#2b3f7a] px-5 py-10">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 md:p-10">
        <div className="flex justify-center mb-6"><Logo height={48} /></div>
        {!token ? (
          <div className="text-center text-[#5a6274]">
            <h1 className="font-head text-2xl font-bold text-[#16244F] mb-2">Invalid link</h1>
            This reset link is missing or invalid.
            <button onClick={() => navigate("/forgot-password")} className="block mx-auto mt-5 text-[#F58220] font-head font-semibold">Request a new link</button>
          </div>
        ) : state === "done" ? (
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#16a34a]/10 text-[#16a34a] mb-4"><CheckCircle2 size={32} /></div>
            <h1 className="font-head text-2xl font-bold text-[#16244F]">Password updated!</h1>
            <p className="text-[#5a6274] mt-2">Redirecting you to login...</p>
          </div>
        ) : (
          <>
            <h1 className="font-head text-2xl font-bold text-[#16244F] text-center">Set a new password</h1>
            <p className="text-center text-[#8a90a0] text-sm mt-1 mb-6">Choose a strong password you'll remember.</p>
            <form onSubmit={submit} className="space-y-4">
              <div className="relative">
                <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8a90a0]" />
                <input type="password" required value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="New password (min 6 characters)" className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-200 focus:border-[#2b8cf0] focus:ring-2 focus:ring-[#2b8cf0]/20 outline-none transition" />
              </div>
              {err && <p className="text-sm text-red-600">{err}</p>}
              <button type="submit" disabled={state === "sending"} className="w-full inline-flex items-center justify-center gap-2 bg-[#F58220] hover:bg-[#e0730f] text-white font-head font-semibold py-3.5 rounded-lg transition-colors disabled:opacity-70">
                {state === "sending" ? <Loader2 size={18} className="animate-spin" /> : <Lock size={18} />} Update Password
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
